import { Component } from '@angular/core'
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap'
import { RowOrigin } from '../../models/source-key.model'

export interface UnmatchSourceOption {
  origin: RowOrigin
  label: string
  color: string
  count: number
}

export interface UnmatchModalResult {
  origin: RowOrigin | 'all'
}

/**
 * Shown when the group being unmatched spans more than one other source, letting the user detach a
 * single source or the whole group. Opened as an NgbModal; resolves with the chosen scope.
 *
 * A port of transactions-2's `components/unmatch-modal` (PVAL-26403 asks for exactly that), kept
 * behaviourally identical so the two workbenches ask the question the same way. The two panels'
 * `RowOrigin` types are separate declarations, so this is a copy rather than a shared component —
 * extracting one into a common lib is a separate refactor.
 */
@Component({
  selector: 'hs-positions-unmatch-modal',
  templateUrl: './unmatch-modal.component.html',
  styleUrls: ['./unmatch-modal.component.scss'],
})
export class UnmatchModalComponent {
  title = ''
  sources: UnmatchSourceOption[] = []

  constructor(readonly activeModal: NgbActiveModal) {}

  choose(origin: RowOrigin | 'all'): void {
    this.activeModal.close({ origin } as UnmatchModalResult)
  }
}
